"use client";

import { useCallback } from "react";
import { useThemeFormatters, useThemeLocale } from "@tranquility-ai/theme-components";
import { formatLocalizedDuration } from "./formatLocalizedDuration";

/**
 * Locale-aware date and number formatting for app chrome.
 *
 * Delegates to theme-components `useThemeFormatters`, which follows the
 * locale mounted by `ThemeLocaleProvider`. Do not call `toLocaleString` or
 * `Intl.*` with a hardcoded `en-US` in product UI.
 */
export function useAppFormatters() {
  const { locale } = useThemeLocale();
  const { formatDate, formatDateTime, formatNumber, formatRelative, formatTime } = useThemeFormatters();
  const formatSavedDuration = useCallback(
    (totalMinutes: number) => formatLocalizedDuration(totalMinutes, locale),
    [locale],
  );
  return { formatDate, formatDateTime, formatTime, formatNumber, formatRelative, formatSavedDuration };
}
